/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-02-23 12:05:58
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-17 11:42:13
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/tools/commonDataCheck/index.ts
 */
import { checkCustomInfomation } from './customsInformation';
import { checkActivePrice } from './price';
import { checkActiveInfo, checkDraftInfo } from './productInfo';
import { instanceType, AllTypes } from 'src/tools/helper';
import { checkAdvancedPrice } from './advancedPrice';

const isSameType = (productType, newType) => {
  return productType == newType;
};
const checkQuantityAndLeftValid = (stock, salesChannelAvailableQuantity) => {
  const total = stock || 0;
  const used = salesChannelAvailableQuantity.reduce((pre, now) => {
    const { quantity } = now || {};
    const _p = pre + quantity || 0;
    return _p;
  }, 0);
  const left = total - used;
  const isNumber =
    instanceType(left) === AllTypes.Number
      ? left === 0
        ? true
        : !!left
      : false;
  return {
    total,
    left: left < 0 || !isNumber ? 0 : left,
    valid: left >= 0,
  };
};

const checkSalesChannelAvailableQuantity = (
  isDraft,
  stockAvailable,
  salesChannelAvailableQuantity,
) => {
  if (isDraft) {
    return { flag: false };
  }
  const { valid } = checkQuantityAndLeftValid(
    stockAvailable,
    salesChannelAvailableQuantity,
  );
  return { flag: !valid };
};

const checkSalesChannelAvailablePresaleQuantity = (
  isDraft,
  quotaEnabled,
  inventoryQuota,
  salesChannelAvailablePresaleQuantity,
) => {
  if (isDraft) {
    return { flag: false };
  }
  if (!quotaEnabled) {
    return { flag: false };
  } else {
    const { valid } = checkQuantityAndLeftValid(
      inventoryQuota,
      salesChannelAvailablePresaleQuantity,
    );
    return { flag: !valid };
  }
};
export {
  isSameType,
  checkCustomInfomation,
  checkActivePrice,
  checkActiveInfo,
  checkDraftInfo,
  checkQuantityAndLeftValid,
  checkSalesChannelAvailableQuantity,
  checkSalesChannelAvailablePresaleQuantity,
  checkAdvancedPrice,
};
